import { render, staticRenderFns } from "./examCommittee.vue?vue&type=template&id=55a9743f&scoped=true&"
import script from "./examCommittee.vue?vue&type=script&lang=js&"
export * from "./examCommittee.vue?vue&type=script&lang=js&"
import style0 from "./examCommittee.vue?vue&type=style&index=0&id=55a9743f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a9743f",
  null
  
)

export default component.exports